import { FC } from "react"
import { WithChildren } from "../../../_metronic/helpers"

const DetailCardShell:FC<WithChildren> = ({children}) => {
  return (
  <div className="card flex-grow-1 min-w-375px mw-850px" >
    {children}
  </div>
  )
}

const DetailCardHeader:FC<WithChildren> = ({children}) => {
  return (
  <div className="card-header pt-8">
    {children}
  </div>
  )
}

const DetailCardBody:FC<WithChildren> = ({children}) => {
  return (
  <div className="card-body d-flex flex-column align-items-stretch gap-2">
    {children}
  </div>
  )
}

type Props = {
  cardTitle?: string    
}

const DetailCard:FC<Props & WithChildren> = ({cardTitle, children}) => {
    return (
    <DetailCardShell>
        {cardTitle &&
        <DetailCardHeader>
            <h3>{cardTitle}</h3>
        </DetailCardHeader>
        }        
        <DetailCardBody>
            {children}
        </DetailCardBody>
    </DetailCardShell>
    )
}

export { DetailCard, DetailCardShell, DetailCardHeader, DetailCardBody }